import { OrderResponse } from "@/types/external"

/**
 * How many of the customer's orders the app asks for on
 * `GET /orders/merchants/:merchantId/by-customer`.
 *
 * The cut is made server-side: the gateway forwards this as `QueryOptions.limit`
 * to order-service-core, which turns it into a SQL LIMIT over a `created_at DESC`
 * sort. Sending it keeps the payload — and core's ~30 preloads per row — bounded,
 * instead of pulling the whole history just to drop most of it here.
 */
export const MAX_CUSTOMER_ORDERS = 10

/**
 * Query string for the by-customer listing, carrying the page size the screens
 * actually render.
 */
export const ordersByCustomerQuery = `?limit=${MAX_CUSTOMER_ORDERS}`

function sortByCreatedAtDesc(a: OrderResponse, b: OrderResponse): number {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
}

/**
 * Normalizes a `by-customer` payload: newest-first, empty for anything that is
 * not an array. The backend already sorts and caps — this only guarantees the
 * order the UI relies on without trusting the wire.
 */
export function sortOrdersByCreatedAtDesc(data: unknown): OrderResponse[] {
  if (!Array.isArray(data)) return []
  return [...(data as OrderResponse[])].sort(sortByCreatedAtDesc)
}
